var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-container has-background-sBlue" }, [
      _c("div", { staticClass: "modal-header" }, [
        _vm._v("\n             Verify Access Code\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body has-background-sBlue" }, [
        _vm._v(
          "\n            Please enter the code that was sent to your email account to verify your access.\n            If you did not receive it in your inbox please be sure to check your junk-email folder.\n            You can also click "
        ),
        _c(
          "a",
          {
            staticClass: "has-text-warning",
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.resend.apply(null, arguments)
              }
            }
          },
          [_vm._v("here")]
        ),
        _vm._v(" to have it resent.\n            "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.checkCode.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "top20 has-text-centered" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.code,
                    expression: "code"
                  }
                ],
                staticClass: "input has-text-centered is-warning is-focused",
                attrs: { id: "textInput", type: "text" },
                domProps: { value: _vm.code },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.code = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showError,
                      expression: "showError"
                    }
                  ],
                  staticClass: "has-text-danger"
                },
                [
                  _vm._v(
                    "\n                        Invalid Code\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSent,
                      expression: "showSent"
                    }
                  ],
                  attrs: { cl: "" }
                },
                [
                  _vm._v(
                    "\n                        New code has been sent\n                    "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "body-bott" }, [
              _c(
                "button",
                {
                  staticClass: "button is-warning is-pulled-right",
                  attrs: { type: "submit", id: "codeButt" }
                },
                [_vm._v("\n                        OK\n                    ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button is-pulled-right",
                  on: { click: _vm.cancel }
                },
                [
                  _vm._v(
                    "\n                        Cancel\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c("br")
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-598eb113", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-598eb113","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalVerifyCode.vue
// module id = null
// module chunks = 